// extracted by mini-css-extract-plugin
module.exports = {"required":"style__required__QpHUP"};